import { CwsPlanCategoryCodeComboBoxModel } from '../cws-plan-category-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * EC商品企画カテゴリ情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetCwsPlanCategoryListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCwsPlanCategoryListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: CwsPlanCategoryCodeComboBoxModel;
  private orderCode: string = null;
  private categoryLevel: string = null;
  private stockLimitFlg: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsPlanCategoryListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        CategoryLevel: this.categoryLevel,
        StockLimitFlg: this.stockLimitFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CwsPlanCategoryCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCwsPlanCategoryListService
   */
  execute(model: CwsPlanCategoryCodeComboBoxModel, orderCode: string, categoryLevel: string,
     stockLimitFlg: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.categoryLevel = categoryLevel;
    this.stockLimitFlg = stockLimitFlg;
    this.successFunc = successFunc;
    this.send('KYMW02getCwsPlanCategoryList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsPlanCategoryListService
   */
  success(data: any) {
    this.model.updateCwsPlanCategoryList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
